import { ChangeDetectorRef, Pipe, PipeTransform } from "@angular/core";
import { I18NextPipe } from "angular-i18next";
import { I18nPipe } from "./i18n.pipe";

abstract class I18nMetadataBasePipe extends I18nPipe implements PipeTransform {
  constructor(
    private key: string,
    translate: I18NextPipe,
    ref: ChangeDetectorRef
  ) {
    super(translate, ref);
  }

  public transform(value: unknown, ...args: unknown[]): unknown {
    const orgValue = value;
    let newValue = (value || "").toString();

    if (!newValue.startsWith(this.key)) {
      newValue = `${this.key}.${newValue}`;
    }

    // metadata can be complex - let's cleanup the key.
    newValue = newValue.replace(/[^a-zA-Z0-9\\.]+/g, "_").replace(/_+/g, "_");

    const result = super.transform(newValue, ...args);
    if (result !== newValue) {
      return result;
    }
    return orgValue;
  }
}

@Pipe({
    name: "i18nMetadata",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class I18nMetadataPipe
  extends I18nMetadataBasePipe
  implements PipeTransform
{
  constructor(translate: I18NextPipe, ref: ChangeDetectorRef) {
    super("circ_metadata.key", translate, ref);
  }
}

@Pipe({
    name: "i18nMetadataValue",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class I18nMetadataValuePipe
  extends I18nMetadataBasePipe
  implements PipeTransform
{
  constructor(translate: I18NextPipe, ref: ChangeDetectorRef) {
    super("circ_metadata.value", translate, ref);
  }
}
